/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';

const defaults = {
  ignoreNetworkEvents: true,
  propagateTraceHeaderCorsUrls: [/.*/g], // Adds trace headers to all outgoing requests for end-to-end tracing
};

export default function initHoneycombTelemetry() {
  const apiKey = process.env.REACT_APP_HONEYCOMB_API_KEY;
  
  if (!apiKey) {
    console.info('Honeycomb telemetry disabled: REACT_APP_HONEYCOMB_API_KEY not configured');
    return;
  }

  try {
    const sdk = new HoneycombWebSDK({
      apiKey,
      serviceName: process.env.REACT_APP_HONEYCOMB_DATASET,
      instrumentations: [
        getWebAutoInstrumentations({
          '@opentelemetry/instrumentation-fetch': defaults,
          '@opentelemetry/instrumentation-xml-http-request': defaults,
          '@opentelemetry/instrumentation-document-load': defaults,
          '@opentelemetry/instrumentation-user-interaction': {
            enabled: true,
            eventNames: ['click', 'submit', 'reset']
          }
        })
      ]
    });
    sdk.start();
  } catch (e) {
    console.error('An error occurred wiring up Honeycomb : ', e);
  }
}
